import * as React from 'react';
import type { SVGProps } from 'react';
const SvgClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10 4.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5M3.25 10a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M10 6.25a.75.75 0 0 1 .75.75v2.25H12a.75.75 0 0 1 0 1.5h-1.75a1 1 0 0 1-1-1V7a.75.75 0 0 1 .75-.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgClock;
